// Hero logo animation - auto-starts on load after 0.5s
// Only runs on homepage and desktop viewports
// Uses GSAP for smooth, slower transitions
class HeroLogoAnimation {
  constructor() {
    this.heroLogo = document.querySelector('.hero__logo');
    this.desktopBreakpoint = 960; // Match $laptop breakpoint
    this.animation = null;
    this.hasAnimated = false;
    
    // Check if we're on homepage
    this.isHomepage = document.body.classList.contains('template-index') || 
                      document.body.classList.contains('template--index');
    
    if (this.heroLogo && this.isHomepage) {
      this.init();
    }
  }

  init() {
    // Check if we're on desktop viewport
    // const isDesktop = window.innerWidth >= this.desktopBreakpoint;
    
    // if (isDesktop && !this.hasAnimated) {
    //   // Wait 0.5s before starting animation
    //   setTimeout(() => {
    //     this.animateLogo();
    //   }, 1000);
    // }

    this.animateLogo();
    
    // Re-check on resize in case user resizes window
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const isDesktopNow = window.innerWidth >= this.desktopBreakpoint;
        if (isDesktopNow && !this.hasAnimated) {
          this.animateLogo();
        } else if (!isDesktopNow && this.hasAnimated) {
          // Reset animation if resized to mobile
          this.resetLogo();
        }
      }, 250);
    });
  }

  animateLogo() {
    if (!this.heroLogo || this.hasAnimated) return;
    
    // Kill any existing animation
    if (this.animation) {
      this.animation.kill();
    }
    
    // Get current position relative to hero container
    const hero = this.heroLogo.closest('.hero');
    const rect = this.heroLogo.getBoundingClientRect();
    const heroRect = hero ? hero.getBoundingClientRect() : { top: 0 };
    const currentTop = rect.top - heroRect.top;
    
    // Animate to top: 30px and width: 360px
    this.animation = gsap.to(this.heroLogo, {
      opacity: 0,
      duration: 1, // Slower, smoother animation
      // ease: 'steps(2)', // Smooth easing
      ease: 'power1.out', // Smooth easing
      scrollTrigger: {
        trigger: hero,
        start: 'top top',
        end: 'bottom 25%',
        scrub: true
        // markers: true
      },
      onComplete: () => {
        this.hasAnimated = true;
      }
    });
  }

  resetLogo() {
    if (this.animation) {
      this.animation.kill();
    }
    
    // Reset to original state
    gsap.set(this.heroLogo, {
      opacity: 1,
      clearProps: 'all'
    });
    
    this.hasAnimated = false;
  }
}

// Initialize on DOMContentLoaded (GSAP should be loaded by then)
document.addEventListener('DOMContentLoaded', () => {
  // Wait for GSAP to be available
  if (typeof gsap !== 'undefined') {
    new HeroLogoAnimation();
  } else {
    // Fallback: wait a bit for GSAP to load
    setTimeout(() => {
      if (typeof gsap !== 'undefined') {
        new HeroLogoAnimation();
      }
    }, 100);
  }
});

